import React from "react";

import Box from "@mui/material/Box";

import { CreateGroupDialog } from "./CreateGroupDialog";
import { GroupList } from "./GroupList";

export const Management = () => {
  return (
    <Box>
      <CreateGroupDialog />
      <GroupList />
    </Box>
  );
};
